import React, { useState } from 'react';
import HelpModal from './HelpModal';
import './FloatingHelpButton.css';

/**
 * Botão flutuante de ajuda com modal
 * @param {Object} props - Propriedades do componente
 * @param {string} props.title - Título da ajuda
 * @param {ReactNode} props.content - Conteúdo da ajuda
 */
const FloatingHelpButton = ({ title = "Ajuda", content }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const openModal = () => {
    setIsModalOpen(true);
  };
  
  const closeModal = () => {
    setIsModalOpen(false);
  };
  
  return (
    <>
      <button 
        className="floating-help-button"
        onClick={openModal}
        aria-label="Ajuda geral"
        title="Clique para obter ajuda"
      >
        <span className="floating-help-icon">?</span>
      </button>
      
      <HelpModal
        isOpen={isModalOpen}
        onClose={closeModal}
        title={title}
        icon="💡"
      >
        {content}
      </HelpModal>
    </>
  );
};

export default FloatingHelpButton;
